module.exports = __webpack_public_path__ + "static/easycookies-5c95ea35829d1e53551367ca97a16b66.svg";